import {ThunkDispatch} from "@reduxjs/toolkit";
import {connect, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import NGphoto from '../../assets/images/NG_all.png'
import NGphoto2 from '../../assets/images/NG_all_2.png'
import NGpanorama from '../../assets/images/NG_panorama.png'

function mapStateToProps(state: any) {
  return {}
}

const ExamplePhotoNG = (props: any) => {
  const {
    tabName,
  } = props
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()

  const isFullHeight = tabName === "itemRemoval" || tabName === "panorama";
  const fullHeightOuterStyle = {height: '528px', display: 'flex' as const, flexDirection: 'column' as const, padding: '12px', overflow: 'hidden'};
  const fullHeightInnerStyle = {flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'};

  const getNGImage = () => {
    if (tabName === "panorama") return NGpanorama;
    if (tabName === "itemRemoval") return NGphoto2;
    return NGphoto;
  };

  return (
    <div className="col-1 border-s border-gray-300" style={isFullHeight ? fullHeightOuterStyle : {}}>
      <div className="overflow-hidden bg-white rounded" style={isFullHeight ? fullHeightInnerStyle : {}}>
        {isFullHeight
          ? <img src={getNGImage()} alt="写真の撮り方" style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', display: 'block'}}/>
          : <img src={getNGImage()} alt="写真の撮り方" className="w-full mx-auto"/>
        }
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(ExamplePhotoNG)